<template>
  <div id="contschool">
    <div class="mui-content contact_box ptop114 bgcolor1">
      <remote-css :href="require('@/assets/mui/css/mui.css')"></remote-css>
      <remote-css :href="require('@/assets/app/css.css')"></remote-css>
      <remote-css :href="require('@/assets/mui/css/mui.css')"></remote-css>
      <remote-css :href="require('@/assets/mui/css/style.css')"></remote-css>
      <div class="contact_content">
        <img :src="model.contract" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "contschool",
    data() {
      return {
        isRead: false,
        model:{}
      }
    },
    methods: {
      /**
       * 获取相关驾校合同
       */
      loadData() {
        var that=this;
        this.$app.pr('/api/school/getSchoolContact.html',{
          "schoolid":that.$app.getParam('schoolid')
        }).then((res) => {
          if (res.success) {
            that.model=res.data;
          }
        }, (res) => {
          console.log(res)
        })
      }
    },
    mounted() {
      var that = this;
      $("#isRead").click(function() {
        if ($(this).prop("checked")) {
          that.isRead = true;
        } else {
          that.isRead = false;
        }
      });

      that.loadData();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Contractschool.vue